import { onBeforeMount, onMounted, ref } from 'vue';

import { useLoadingStore } from '@/stores/loading';

interface UseListViewOptions {
  fetchData: () => Promise<unknown>;
}

export function useListView({ fetchData }: UseListViewOptions) {
  const loadingStore = useLoadingStore();
  const isLoadingFinished = ref(false);

  onBeforeMount(() => {
    loadingStore.startLoading();
  });

  onMounted(async () => {
    loadingStore.startLoading();
    try {
      await fetchData();
    } catch (error) {
      console.error('Error in onMounted:', error);
    } finally {
      loadingStore.stopLoading();
      isLoadingFinished.value = true;
    }
  });

  return { isLoadingFinished };
}
